export const SESSION_EXPIRED = 'SESSION_EXPIRED';

export function sessionExpired() {
    return {
        type: SESSION_EXPIRED
    };
}


// WEBPACK FOOTER //
// ./js/actions/auth/sessionExpiredAction.js